/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Banner_Add_HintInputs */



/**
* | output |
* | --- |
* | "Recommended 1200 × 630" |
*
* @param {Tournament_Banner_Add_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_banner_add_hint = /** @type {((inputs?: Tournament_Banner_Add_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Banner_Add_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recommandé 1200 × 630")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recomendado 1200 × 630")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Recomendado 1200 × 630")
	if (locale === "it") return /** @type {LocalizedString} */ ("Consigliato 1200 × 630")
	return /** @type {LocalizedString} */ ("Recommended 1200 × 630")
});